export * from './CommentRectPlusIcon';
export * from './CommentRectPlusIcon16Light';
export * from './CommentRectPlusIcon16Regular';
export * from './CommentRectPlusIcon16Solid';
export * from './CommentRectPlusIcon20Light';
export * from './CommentRectPlusIcon20Regular';
export * from './CommentRectPlusIcon20Solid';
export * from './CommentRectPlusIcon24Regular';
export * from './CommentRectPlusIcon24Solid';
export * from './CommentRectPlusIcon32Regular';
export * from './CommentRectPlusIcon64Regular';
